import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import TransferActivityPage, { getDefaultPageUI } from "components/pages/TransferActivityPage";
import ScheduledTransfersPage from "components/pages/TransferActivityPage/components/ScheduledTransfersPage";

/**
 * @name CaptureTransfersActivityScheduled
 * @returns {React.Component}
 * @description The capture component for the transfers actvity with the scheduled tab showning
 */
export default function CaptureTransfersActivityScheduled(props) {
    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // updating the content and scheduledTransfers properties
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        // Sets the component to be used for the content
        .update([ "content" ], ScheduledTransfersPage)
        // Sets the tab to be selected
        .update([ "scheduledTransfers", "isActive" ], true)
        .submit();

    // Return the TransferActivityPage passing the ui variable
    return <TransferActivityPage ui={ ui } />
}